import "ant-design-vue/es/collapse/style";
import _Collapse from "ant-design-vue/es/collapse";
import "ant-design-vue/es/radio/style";
import _Radio from "ant-design-vue/es/radio";
import "ant-design-vue/es/slider/style";
import _Slider from "ant-design-vue/es/slider";
import "ant-design-vue/es/timeline/style";
import _Timeline from "ant-design-vue/es/timeline";
import "ant-design-vue/es/tag/style";
import _Tag from "ant-design-vue/es/tag";
import "ant-design-vue/es/tabs/style";
import _Tabs from "ant-design-vue/es/tabs";
import "ant-design-vue/es/table/style";
import _Table from "ant-design-vue/es/table";
import "ant-design-vue/es/skeleton/style";
import _Skeleton from "ant-design-vue/es/skeleton";
import "ant-design-vue/es/select/style";
import _Select from "ant-design-vue/es/select";
import "ant-design-vue/es/popover/style";
import _Popover from "ant-design-vue/es/popover";
import "ant-design-vue/es/row/style";
import _Row from "ant-design-vue/es/row";
import "ant-design-vue/es/result/style";
import _Result from "ant-design-vue/es/result";
import "ant-design-vue/es/pagination/style";
import _Pagination from "ant-design-vue/es/pagination";
import "ant-design-vue/es/spin/style";
import _Spin from "ant-design-vue/es/spin";
import "ant-design-vue/es/menu/style";
import _Menu from "ant-design-vue/es/menu";
import "ant-design-vue/es/layout/style";
import _Layout from "ant-design-vue/es/layout";
import "ant-design-vue/es/icon/style";
import _Icon from "ant-design-vue/es/icon";
import "ant-design-vue/es/input/style";
import _Input from "ant-design-vue/es/input";
import "ant-design-vue/es/form/style";
import _Form from "ant-design-vue/es/form";
import "ant-design-vue/es/empty/style";
import _Empty from "ant-design-vue/es/empty";
import "ant-design-vue/es/dropdown/style";
import _Dropdown from "ant-design-vue/es/dropdown";
import "ant-design-vue/es/drawer/style";
import _Drawer from "ant-design-vue/es/drawer";
import "ant-design-vue/es/divider/style";
import _Divider from "ant-design-vue/es/divider";
import "ant-design-vue/es/alert/style";
import _Alert from "ant-design-vue/es/alert";
import "ant-design-vue/es/col/style";
import _Col from "ant-design-vue/es/col";
import "ant-design-vue/es/config-provider/style";
import _ConfigProvider from "ant-design-vue/es/config-provider";
import "ant-design-vue/es/checkbox/style";
import _Checkbox from "ant-design-vue/es/checkbox";
import "ant-design-vue/es/carousel/style";
import _Carousel from "ant-design-vue/es/carousel";
import "ant-design-vue/es/breadcrumb/style";
import _Breadcrumb from "ant-design-vue/es/breadcrumb";
import "ant-design-vue/es/descriptions/style";
import _Descriptions from "ant-design-vue/es/descriptions";
import "ant-design-vue/es/popconfirm/style";
import _Popconfirm from "ant-design-vue/es/popconfirm";
import "ant-design-vue/es/steps/style";
import _Steps from "ant-design-vue/es/steps";
import "ant-design-vue/es/button/style";
import _Button from "ant-design-vue/es/button";
import "ant-design-vue/es/avatar/style";
import _Avatar from "ant-design-vue/es/avatar";
import "ant-design-vue/es/modal/style";
import _Modal from "ant-design-vue/es/modal";
import "ant-design-vue/es/message/style";
import _message from "ant-design-vue/es/message";
import Vue from 'vue';
Vue.prototype.$message = _message;
Vue.prototype.$info = _Modal.info;
Vue.prototype.$success = _Modal.success;
Vue.prototype.$error = _Modal.error;
Vue.prototype.$warning = _Modal.warning;
Vue.prototype.$confirm = _Modal.confirm;
Vue.prototype.$destroyAll = _Modal.destroyAll;
Vue.use(_Avatar);
Vue.use(_Button);
Vue.use(_Steps);
Vue.use(_Popconfirm);
Vue.use(_Descriptions);
Vue.use(_Breadcrumb);
Vue.use(_Carousel);
Vue.use(_Checkbox);
Vue.use(_ConfigProvider);
Vue.use(_Col);
Vue.use(_Alert);
Vue.use(_Divider);
Vue.use(_Drawer);
Vue.use(_Dropdown);
Vue.use(_Empty);
Vue.use(_Form);
Vue.use(_Input);
Vue.use(_Icon);
Vue.use(_Layout);
Vue.use(_Menu);
Vue.use(_Modal);
Vue.use(_Spin);
Vue.use(_Pagination);
Vue.use(_Result);
Vue.use(_Row);
Vue.use(_Popover);
Vue.use(_Select);
Vue.use(_Skeleton);
Vue.use(_Table);
Vue.use(_Tabs);
Vue.use(_Tag);
Vue.use(_Timeline);
Vue.use(_Slider);
Vue.use(_Radio);
Vue.use(_Collapse);